import { render, staticRenderFns } from "./PersonnelTabContent.vue?vue&type=template&id=1d63688a&"
import script from "./PersonnelTabContent.vue?vue&type=script&lang=js&"
export * from "./PersonnelTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports